import React from 'react';
import { Routes } from 'react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AdminSettings } from './views';
import RemoveUserAssociations from './views/admin/RemoveUserAssociation';
import EditUser from './views/EditUser';

const App: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Router basename="/user-management">
      <Routes>
        <Route path="/admin/*" element={<AdminSettings />} />
        <Route path="/admin/users/:id" element={<EditUser />} />
        <Route path="/admin/users/:id/remove" element={<RemoveUserAssociations />} />
        <Route path="/" element={<div>{t('pages.unauthorized.title')}</div>} />
      </Routes>
    </Router>
  );
};

export default App;
